//Utils
import { scrollRestoration } from 'Scripts/utils/Scroll'
import { isTouchDevice, deviceType } from 'Scripts/utils/utils'
//Vendor
import barba from '@barba/core'
// import { ScrollTrigger } from "gsap/ScrollTrigger"
import Lenis from '@studio-freight/lenis'
import axios from 'axios'
//Components
import Preloader from 'Scripts/components/Preloader'
import Cursor from 'Scripts/components/cursor'
import Lines from 'Scripts/components/Lines'
import Header from 'Scripts/components/header'
import Transition from 'Scripts/components/Transition'
import Roll from 'Scripts/components/Roll'

//Pages
import Editorial from 'Scripts/pages/Editorial'
import Home from 'Scripts/pages/Home'
import Groupe from 'Scripts/pages/Groupe'
import Metier from 'Scripts/pages/Metier'
import Realisation from 'Scripts/pages/Realisation'
import News from 'Scripts/pages/News'
import Carriere from 'Scripts/pages/Carriere'
import Contact from 'Scripts/pages/Contact'
import Documents from 'Scripts/pages/Documents'

class App {
  constructor() {
    //Token and config axios
    // this.getToken()
    this.authAttempts = 0 // Compteur de tentatives
    this.maxAuthAttempts = 3 // Limite des tentatives
    this.isAuthenticating = false // Verrou pour éviter les appels simultanés
    this.getTokenPro()
    //Slug
    //delete the last / if exist
    this.pathname = window.location.pathname.replace(/\/$/, '')
    // remove first and last /
    this.pathname = this.pathname.replace(/^\//, '').replace(/\/$/, '')
    //get slug
    this.slug = this.pathname.split('/')[this.pathname.split('/').length - 1]

    //Variables
    this.template = document.querySelector('body').dataset.page
    this.theme = document.querySelector('body').dataset.theme
    this.color = document.querySelector('body').dataset.color

    //Developed By
    // this.developedBy()
    //scrollRestoration
    scrollRestoration()
    //
    isTouchDevice() && document.documentElement.classList.add('isTouchDevice')
    const isMobile = deviceType() === 'mobile'
    //Smooth Scroll : Lenis
    !isMobile && this.initSmoothScrolling()
    //Pages
    this.createPages()
    //Cursor
    !isMobile && this.createCursor()
    //Preloader
    this.createPreloader()
    //Listeners
    this.addEventListeners()
    //Transition
    this.createTransition()
    this.initTransition()

    //
  }

  //Developed by
  developedBy() {
    console.log('%cDeveloped by EMB', 'color:blue; font-style: italic; padding: 5px')
  }

  //Preloader
  createPreloader() {
    this.preloader = new Preloader({
      selector: '#preloader__wrapper',
      counter: '.preloader__counter',
      logo: '.preloader__logo',
    })
    this.preloader.once('completed', this.onPreloaded.bind(this))
  }

  //On siteweb Preloaded
  onPreloaded() {
    //Resize event
    // this.onResize()
    //Lines
    this.createLines()
    // Roll
    this.initRoll()
    //header
    this.initHeader()
    //Show page
    this.page.show()
    // console.log(this.template, this.pathname, this.slug)
    if (this.slug !== '' && this.slug !== this.template) {
      // console.log('single page')
      const link = document.querySelector(`[data-slug="${this.slug}"]`)
      // console.log(link)
      link && link.click()
    }
  }

  //Create pages
  createPages() {
    switch (this.template) {
      case 'home':
      case 'accueil':
        this.page = new Home()
        break
      case 'groupe':
        this.page = new Groupe({ scroller: this.lenis })
        break
      case 'metiers':
        this.page = new Metier()
        break
      case 'realisations':
        this.page = new Realisation()
        break
      case 'medias':
        this.page = new News()
        break
      case 'carriere':
        this.page = new Carriere()
        break
      case 'documents':
        this.page = new Documents()
        break
      case 'contact':
        this.page = new Contact()
        break
      default:
        this.page = new Editorial()
    }
  }

  async getToken() {
    // const Token = btoa(`${process.env.USERNAME}:${process.env.PASSWORD}`)
    // console.log(Token)
    //get token from session
    this.token = sessionStorage.getItem('token')
    //get token from api
    if (!this.token) {
      this.token = process.env.WP_REST_API_TOKEN
      sessionStorage.setItem('token', this.token)
      axios.defaults.headers.common['Authorization'] = `Basic ${this.token}`
    } else {
      axios.defaults.headers.common['Authorization'] = `Basic ${this.token}`
    }

    // if (typeof sgtmVars !== 'undefined' && sgtmVars.apiSecret) {
    //   axios.defaults.headers.common['X-SGTM-SECRET'] = sgtmVars.apiSecret
    // } else {
    //   console.error('sgtmVars n’est pas défini ! Vérifie wp_localize_script')
    // }

    //axios config
    if (this.token) {
      axios.defaults.headers.common['Content-Type'] = 'application/json'
      // axios.defaults.headers.common['x-origin'] = window.location.origin
      // axios.defaults.headers.common['X-WP-Nonce'] = apiVars.nonce
    }
  }

  configureAxios() {
    // Configuration d'axios pour utiliser les cookies HttpOnly
    axios.defaults.withCredentials = true
    axios.defaults.headers.common['Content-Type'] = 'application/json'
    // axios.defaults.headers.common['Origin'] = window.location.origin // INTERDIT : Le navigateur bloque ce header
    // Supprimer l'ancien header Authorization si présent
    delete axios.defaults.headers.common['Authorization']

    // Intercepteur pour gérer l'expiration automatique du token
    axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response?.status === 401) {
          // console.log('Token expiré, ré-authentification...')
          // Réessayer l'authentification
          await this.authenticate()
          // Réessayer la requête originale
          return axios.request(error.config)
        }
        return Promise.reject(error)
      }
    )
  }

  async authenticate() {
    if (this.isAuthenticating) {
      // console.log('Authentification déjà en cours...')
      return false
    }
    // Vérifier le nombre de tentatives
    if (this.authAttempts >= this.maxAuthAttempts) {
      // console.error("Nombre maximum de tentatives d'authentification atteint")
      // this.fallbackToBasicAuth()
      return false
    }

    this.isAuthenticating = true
    this.authAttempts++
    try {
      const response = await axios.post(
        `${process.env.SGTMAPI}/auth`,
        {},
        // {
        //   username: process.env.USERNAME,
        //   password: process.env.PASSWORD,
        // },
        {
          withCredentials: true,
        }
      )

      if (response.data.success) {
        this.configureAxios()
        // console.log('Authentification réussie')
        // Réinitialiser les compteurs en cas de succès
        this.authAttempts = 0
        this.isAuthenticating = false
        return true
      }
    } catch (error) {
      // console.error("Erreur d'authentification:", error)
      // this.getTokenPro() // Réessayer l'authentification
      // Si on a atteint la limite, basculer vers le fallback
      if (this.authAttempts >= this.maxAuthAttempts) {
        // console.log("Basculement vers l'authentification basique")
        return false
        // this.fallbackToBasicAuth()
      }
    } finally {
      this.isAuthenticating = false
    }
  }

  async getTokenPro() {
    try {
      // 1. VÉRIFICATION D'UNE SESSION EXISTANTE
      // Appel à l'endpoint /verify pour vérifier si un cookie valide existe
      const response = await axios.get(`${process.env.SGTMAPI}/auth/verify`, {
        withCredentials: true, // Crucial : envoie automatiquement les cookies HttpOnly
      })

      if (response.status === 200 && response.data.valid) {
        // 2. SESSION VALIDE TROUVÉE
        // Configure axios pour les futures requêtes avec cookies
        this.configureAxios()
        // console.log('Session valide trouvée')
        return // Sortie anticipée, pas besoin d'authentification
      }
    } catch (error) {
      // 3. AUCUNE SESSION VALIDE
      // Le catch se déclenche si :
      // - Pas de cookie
      // - Cookie invalide/expiré
      // - Erreur serveur
      console.log('Aucune session valide, authentification nécessaire')
    }

    // 4. AUTHENTIFICATION NÉCESSAIRE
    await this.authenticate()
  }

  // async getToken1() {
  //   await axios
  //     .post(`${process.env.SITE}/wp-json/jwt-auth/v1/token`, {
  //       username: process.env.USERNAME,
  //       password: process.env.PASSWORD,
  //     })
  //     .then((response) => {
  //       // this.token = response.data.token
  //       console.log('get token')
  //       //axios config
  //       // axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`
  //     })
  //     .catch((error) => {
  //       console.log(error.message)
  //     })
  // }

  onResize() {
    if (this.page && this.page.onResize) {
      this.page.onResize()
    }
  }

  onUpdate() {
    if (this.page && this.page.onUpdate) {
      this.page.onUpdate()
    }
  }

  createTransition() {
    this.transition = new Transition()
  }

  createCursor() {
    this.cursor = new Cursor(document.querySelector('.cursor__wrapper'))
  }

  createLines() {
    this.lines = new Lines({
      selector: '[data-scroll-container] > .lines',
      wrapper: '[data-scroll-container]',
    })
  }

  initRoll() {
    // this.roll = new Roll({ selector: '.home-roll', duration: 25 })
    this.roll = new Roll({ selector: '.home-roll' })
  }

  initHeader() {
    // this.headerObject = new Header({ scroller: this.locoScroller, selector: '#header' })
    this.headerObject = new Header({ scroller: this.lenis, selector: '#header' })
  }

  initTransition() {
    let that = this

    barba.hooks.before(() => {
      document.querySelector('html').classList.add('is-transitioning')
    })

    barba.hooks.beforeLeave(() => {
      // this.locoScroller.destroy()
    })

    barba.hooks.afterLeave(() => {
      window.scrollTo(0, 0)
    })

    barba.hooks.beforeEnter((data) => {
      data.current.container && data.current.container.remove()
    })

    barba.hooks.enter(() => {
      // this.locoScroller.init()
    })

    barba.init({
      debug: false,
      sync: true,
      prefetchIgnore: true,
      preventRunning: true,
      schema: {
        prefix: 'data-transition',
      },
      transitions: [
        {
          name: 'default',
          once() {},
          async leave() {
            await that.transition.show({ color: that.color })
          },
          async after(data) {
            document.querySelector('html').classList.remove('is-transitioning')
            //Update Scroller
            // that.locoScroller.update()
            //Update body attribut
            that.template = data.next.container.dataset.transitionNamespace
            that.theme = data.next.container.dataset.pageTheme
            that.color = data.next.container.dataset.color
            document.querySelector('body').dataset.theme = that.theme
            document.querySelector('body').dataset.page = that.template
            document.querySelector('body').dataset.color = that.color

            //Update components
            that.createPages()
            that.lines.onResize()
            await that.transition.hide()
            that.page.show()
          },
        },
        {
          name: 'self',
          async leave() {
            return that.transition.show({
              color: that.color,
            })
          },
          async after() {
            //
            document.querySelector('html').classList.remove('is-transitioning')
            that.createPages()
            that.lines.onResize()
            await that.transition.hide()
            that.page.show()
          },
        },
      ],
    })
  }

  // Smooth scrolling initialization (using Lenis https://github.com/studio-freight/lenis)
  initSmoothScrolling() {
    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), // https://easings.net
      orientation: 'vertical',
      smoothWheel: true,
      smoothTouch: false,
    })

    const scrollFn = (time) => {
      this.lenis.raf(time)
      requestAnimationFrame(scrollFn)
    }
    requestAnimationFrame(scrollFn)
  }

  // initScrollTrigger(scroll) {

  //   scroll.on("scroll", () => ScrollTrigger.update())
  //   //
  //   ScrollTrigger.scrollerProxy("[data-scroll-container]", {
  //     scrollTop(value) {
  //       return arguments.length ? scroll.scrollTo(value, 0, 0) : scroll.scroll.instance.scroll.y;
  //     }, // we don't have to define a scrollLeft because we're only scrolling vertically.
  //     getBoundingClientRect() {
  //       return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
  //     },
  //     // smooth scroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the smooth scroll controlled element).
  //     pinType: document.querySelector("[data-scroll-container]").style.transform ? "transform" : "fixed"
  //   })

  //   //
  //   ScrollTrigger.defaults({
  //     scroller: document.querySelector('[data-scroll-container]'),
  //   })
  //   // each time the window updates, we should refresh ScrollTrigger and then update smooth scroll.
  //   ScrollTrigger.addEventListener('refresh', () => scroll.update())

  //   // after everything is set up, refresh() ScrollTrigger and update smooth scroll because padding may have been added for pinning, etc.
  //   ScrollTrigger.refresh()

  // }

  addEventListeners() {
    window.addEventListener('resize', this.onResize.bind(this))
    // window.addEventListener('popstate', this.onPopState.bind(this))
  }

  // onPopState() {
  //   const pathname = window.location.pathname
  //   const url = window.location.href
  //   if (this.push) {
  //     window.history.pushState({}, '', url)
  //   }
  // }

  /**
   * Loop.
   */
  // update() {

  //   if (this.page) {
  //     this.page.update()
  //   }

  //   window.requestAnimationFrame(this.update.bind(this))
  // }
}

new App()
